@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  <div class="cv-parse-container flex">
    <input
      #fileUploadInput
      accept="application/pdf, .pdf"
      class="file-input"
      data-test-id="cv-parse-file-input"
      type="file"
    />
    <button
      [ngClass]="{ 'small-button': breakpoints.ltMd }"
      (click)="fileUploadInput.click()"
      #fileUploadButton
      cdkFocusInitial
      color="primary"
      data-test-id="cv-parse-control-button"
      mat-flat-button
      type="button"
    >
      Upload PDF
    </button>
  </div>
}
